import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Refund = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 container mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold mb-8">Refund Policy</h1>
        
        <div className="prose prose-gray max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">Overview</h2>
            <p className="text-muted-foreground">
              At NoteGenius, we strive to provide the best AI-powered note processing experience. 
              We understand that sometimes things don't work out as expected, and we're here to help.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Credit Refunds</h2>
            <p className="text-muted-foreground">
              Refund requests for unused credits are accepted within 7 days of purchase. 
              Credits that have already been used for processing notes are non-refundable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Eligibility</h2>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Refund requests must be made within 7 days of the original purchase</li>
              <li>Only unused credits are eligible for refund</li>
              <li>Technical issues on our end that prevent service delivery</li>
              <li>Duplicate or accidental purchases</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">How to Request a Refund</h2>
            <p className="text-muted-foreground">
              To request a refund, please contact our support team at{" "}
              <a href="mailto:support@notegenius.com" className="text-primary hover:underline">
                support@notegenius.com
              </a>{" "}
              with the following information:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 mt-2">
              <li>Your registered email address</li>
              <li>Date of purchase</li>
              <li>Reason for refund request</li>
              <li>Payment transaction ID (if available)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Processing Time</h2>
            <p className="text-muted-foreground">
              Refund requests are typically processed within 5-7 business days. 
              Once approved, the refund will be credited to your original payment method 
              within 5-10 business days depending on your bank or payment provider.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
            <p className="text-muted-foreground">
              If you have any questions about our refund policy, please don't hesitate to{" "}
              <a href="/contact" className="text-primary hover:underline">
                contact us
              </a>.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Refund;
